import { slideDown, slideUp } from '../utiles/index.js';

const initPages = () => {
	const jobItems = document.querySelectorAll('.job-item');
	if (jobItems.length) {
		jobItems.forEach((item) => {
			const btn = item.querySelector('.job-item__header');
			const content = item.querySelector('.job-item__body');
			btn.addEventListener('click', () => {
				if (item.classList.contains('show')) {
					item.classList.remove('show');
					slideUp(content);
				} else {
					item.classList.add('show');
					slideDown(content);
				}
			});
		});
		jobItems[0].querySelector('.job-item__header').click();
	}

	// Contact Us
};

export { initPages };
